import { render, staticRenderFns } from "./TextInputConfig.vue?vue&type=template&id=5a2e2d58&scoped=true"
import script from "./TextInputConfig.vue?vue&type=script&lang=js"
export * from "./TextInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e2d58",
  null
  
)

export default component.exports